import { api } from '@/shared/api/base';

export interface AiSource {
  id: string;
  title: string;
  url?: string | null;
}

export interface AiSuggestion {
  type: 'create_ticket' | 'portal_link' | 'wiki_article';
  label: string;
  href?: string;
  categoryId?: string;
  subcategoryId?: string;
  summary?: string;
}

export type AiRating = 'up' | 'down';

export interface AiMessage {
  id: string;
  chatId: string;
  role: 'user' | 'assistant';
  content: string;
  sources?: AiSource[] | null;
  suggestions?: AiSuggestion[] | null;
  rating?: AiRating | null;
  ratingReason?: string | null;
  createdAt?: string;
}

export interface AiChatSummary {
  id: string;
  title: string | null;
  status: 'active' | 'archived';
  tokenEstimate: number;
  createdAt: string;
  updatedAt: string;
}

export interface AiHealth {
  load: 'normal' | 'busy' | 'overloaded';
  queueDepth: number;
  aiCore: {
    ok: boolean;
    index_chunks?: number;
    ollama_ok?: boolean;
    problems?: string[];
  };
}

export const aiApi = {
  listChats: () => api.get<AiChatSummary[]>('/api/v1/ai/chats'),
  createChat: () => api.post<AiChatSummary>('/api/v1/ai/chats', {}),
  messages: (chatId: string) => api.get<AiMessage[]>(`/api/v1/ai/chats/${chatId}/messages`),
  rate: (messageId: string, rating: AiRating | null, reason?: string) =>
    api.post<{ ok: boolean }>(`/api/v1/ai/messages/${messageId}/rating`, { rating, reason }),
  health: () => api.get<AiHealth>('/api/v1/ai/health'),
};
